// Utility functions for PDF generation
// This file provides shared utilities for working with @react-pdf/renderer

// Format number helper
export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined || value === 0) return '-';
  return value.toFixed(2);
};

// Format date helper
export const formatDate = (date: any): string => {
  if (!date) return '';
  try {
    const d = new Date(date);
    return d.toLocaleDateString('fi-FI');
  } catch {
    return '';
  }
};

// Sanitize filename
export const sanitizeFilename = (baseName: string, timestamp: boolean = true): string => {
  const sanitized = baseName.replace(/[^A-Za-z0-9_-]/g, '_').replace(/_{2,}/g, '_');
  const ts = timestamp 
    ? `_${new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '').replace('T', '_')}`
    : '';
  return `${sanitized}${ts}.pdf`;
};

// Generate timestamp string for filenames
export const generateTimestamp = (): string => {
  return new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '').replace('T', '_');
};

// Sanitize a string for use in filenames
export const sanitizeForFilename = (text: string): string => {
  return text.replace(/[^A-Za-z0-9_-]/g, '_').replace(/_{2,}/g, '_');
};

// Format currency with Euro symbol
export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return `${value.toFixed(2)} €`;
};

// Format current date or specific date in Finnish format (day.month.year)
export const formatFinnishDate = (date?: Date | string | null): string => {
  const d = date ? new Date(date) : new Date();
  return d.toLocaleDateString('fi-FI');
};
